
import { Watch, Mixins, Component, Ref, InjectReactive, Emit } from "vue-property-decorator";

import TablePagination from "@/mixins/tablePagination";
import Resize from "@/mixins/resize";

import ETable from "@/components/ETable.vue";

import { ElForm } from "element-ui/types/form";

import { detectionSummaryLog } from "@/api/userDetection";

@Component({
  components: {
      ETable,
  }
})
export default class UserBuyRecord extends Mixins(Resize, TablePagination) {
    @Ref("addFormRef") AddFormRef!: ElForm;
    @InjectReactive() activeName!: string;
    
    queryForm = {
        phone: "",
        nickname: "",
    }

    loading = false;
    itemTotal = 0;
    tableData = [];

    columns = [
        { label: "用户名称", prop: "nickname" },
        { label: "用户手机号", prop: "phone" },
        { label: "诊断类型", prop: "diagnosesTypeDesc" },
        { label: "添加次数", prop: "buyNum" },
        { label: "添加人", prop: "modifiedBy" },
        { label: "添加日期", prop: "modifiedTime" },
        { label: "备注", prop: "remark" },
    ]

    diagnosesTypeOptions = [
        {label: "舌诊",value: "10001"},
        {label: "体质辨识",value: "10004"},
    ];

    mounted() {
        this.windowResize(480);
    }

    //重置分页参数
    resetPages() {
        this.currentPage = 1;
    }

    // 搜索
    handleSearch() {
        this.resetPages();
        this.getData();
    }

    @Watch("activeName", { immediate: true })
    getData() {
        if (this.activeName !== "second") return;
        const params = {
            ...this.queryForm,
            pageNum: this.currentPage,
            pageSize: this.pageSize,
        }
        this.loading = true;
        detectionSummaryLog(params).then((res) => {
            const { total, list } = res.data;
            list.forEach((record) => {
                record.diagnosesTypeDesc = this.diagnosesTypeOptions.find((el) => el.value == record.diagnosesType)?.label;
            })
            this.tableData = list;
            this.itemTotal = total;
        }).finally(() => {
            this.loading = false;
        })
    }

    searchData() {

    }

}
